"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Mustache = require("mustache");
var page_runtime_component_loader_service_1 = require("../shared/page-runtime-component-loader.service");
require("./designer-filter-settings.component.scss");
var DesignerFilterSettingsComponent = /** @class */ (function () {
    function DesignerFilterSettingsComponent(runtimeWidgetLoaderService) {
        this.runtimeWidgetLoaderService = runtimeWidgetLoaderService;
        this._onCloseEmitter = new core_1.EventEmitter();
    }
    DesignerFilterSettingsComponent_1 = DesignerFilterSettingsComponent;
    Object.defineProperty(DesignerFilterSettingsComponent.prototype, "isActive", {
        get: function () {
            return this._isActive;
        },
        set: function (value) {
            this._isActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DesignerFilterSettingsComponent.prototype, "onClose", {
        get: function () {
            return this._onCloseEmitter;
        },
        enumerable: true,
        configurable: true
    });
    DesignerFilterSettingsComponent.stateChange = function ($event, widget) {
        widget.state = $event;
    };
    DesignerFilterSettingsComponent.getResolvedTemplate = function (widget) {
        var resultMap = {
            state: 'widget.stateForSetting',
            id: 'widget.id',
            stateChange: 'stateChange($event, widget)',
        };
        Mustache.parse(widget.widgetMeta.settings.bottom.template, ['%{', '}']);
        return Mustache.render(widget.widgetMeta.settings.bottom.template, resultMap);
    };
    DesignerFilterSettingsComponent.prototype.close = function () {
        this._onCloseEmitter.emit(true);
    };
    DesignerFilterSettingsComponent.prototype.cleanup = function () {
        this.settingsFilterContainer.remove();
    };
    DesignerFilterSettingsComponent.prototype.initSettings = function (widget) {
        this.initWidget(widget);
        this.currentWidget = widget;
    };
    DesignerFilterSettingsComponent.prototype.initWidget = function (widget) {
        var contextMapping = new Map();
        contextMapping.set('widget', widget);
        contextMapping.set('stateChange', DesignerFilterSettingsComponent_1.stateChange);
        this.runtimeWidgetLoaderService.initComponent(this.settingsFilterContainer, widget.widgetMeta.selector, contextMapping, DesignerFilterSettingsComponent_1.getResolvedTemplate(widget));
    };
    var DesignerFilterSettingsComponent_1;
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], DesignerFilterSettingsComponent.prototype, "isActive", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [])
    ], DesignerFilterSettingsComponent.prototype, "onClose", null);
    __decorate([
        core_1.ViewChild('settingsFilterContainer', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.ViewContainerRef)
    ], DesignerFilterSettingsComponent.prototype, "settingsFilterContainer", void 0);
    DesignerFilterSettingsComponent = DesignerFilterSettingsComponent_1 = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'designer-filter-settings',
            template: require('./designer-filter-settings.component.html'),
        }),
        __metadata("design:paramtypes", [page_runtime_component_loader_service_1.PageRuntimeComponentLoaderService])
    ], DesignerFilterSettingsComponent);
    return DesignerFilterSettingsComponent;
}());
exports.DesignerFilterSettingsComponent = DesignerFilterSettingsComponent;
//# sourceMappingURL=designer-filter-settings.component.js.map